const BASE_URL = "https://api.deeclass.com/api";
// const BASE_URL = "http://localhost:5001/api";

export const FRONTEND_URL = "https://api.deeclass.com";
// export const FRONTEND_URL = "http://localhost:3001";

export default BASE_URL;
